import { gql } from '@apollo/client';

export const METRIC_RECORD_BASE_FIELDS = gql`
  fragment MetricRecordBaseFields on MetricRecord {
    id
    value
    metric
    standard
  }
`;
